import React, { useEffect, useState } from 'react';
import cookie from 'react-cookie';
import ErrorBoundary from '../common/ErrorBoundary';
import { post } from '../common/fetch';
import ForthcomingModal from './ForthcomingModal';

const InterestModal = ({ open, developmentId, development, onClose }) => {
  const [alreadySubmitted, setAlreadySubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const interests = cookie.load('interests') || [];
    const submitted = interests.includes(developmentId);

    setAlreadySubmitted(submitted);
    setSubmitted(false);
  }, [developmentId]);

  const submit = (data: any) => {
    setLoading(true);
    post('/development/forthcoming/interest', data)
      .then(() => {
        setLoading(false);
        setSubmitted(true);
        setError(false);
        onClose();
        const interests = cookie.load('interests') || [];
        interests.push(data.developmentid);
        cookie.save('interests', interests);
      })
      .catch((err) => {
        setError(err.response.data.message || 'Unknown Error');
        setLoading(false);
      });
  };

  return (
    <>
      {submitted && (
        <div className="alert alert-success">Successfully registered interest in development</div>
      )}
      {open && (
        <ErrorBoundary showDialog>
          <ForthcomingModal
            developmentId={developmentId}
            development={development}
            loading={loading}
            alreadySubmitted={alreadySubmitted}
            error={error}
            onSubmit={submit}
            onClose={onClose}
          />
        </ErrorBoundary>
      )}
    </>
  );
};

export default InterestModal;
